import { KebabMenu, KebabMenuItem } from '@library/components/menus';
import { classNames } from '@library/utils';

export interface ScoringKebabMenuProps {
  disabled: boolean;
  handleShowHistoryDrawer: () => void;
}

export const ScoringKebabMenu = ({
  disabled,
  handleShowHistoryDrawer
}: ScoringKebabMenuProps) => {
  return (
    <KebabMenu
      className="relative flex size-12 items-center"
      disabled={disabled}
      float
      floatPlacement="bottom-end"
      menuButtonClassName={classNames(
        disabled ? 'cursor-not-allowed' : '',
        'self-center'
      )}
      menuItemsClassName="border border-soFresh-140 bg-soFresh-110 right-0 text-xs rounded-md"
      menuButtonOpenClassName="rounded-md bg-soFresh-140"
      title="ScoringKebabMenu"
    >
      <KebabMenuItem
        key="player-details"
        className="text-soClean-100 hover:bg-soFresh-120 flex h-7 w-full items-center rounded-md p-4 text-xs"
        disabled={disabled}
        handleOnClick={handleShowHistoryDrawer}
        itemActiveClassName="bg-stankonia-100"
      >
        <span className="p-3">Show History Drawer</span>
      </KebabMenuItem>
    </KebabMenu>
  );
};
